<template>
  <div class="supplier">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('license'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <v-btn
            class="button_size mr-5"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_license") }}
          </v-btn>
        </v-sheet>
      </v-col>
      <v-col cols="auto" class="mr-12">
        <v-sheet>
          <v-btn
            class="button_size"
            color="orange"
            prepend-icon="mdi-upload"
            @click="compose_excel"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            <p style="color: white">{{ $t("batch_upload") }}</p>
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
      <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_organization" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-container v-else class="pl-0 ml-0">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="licenses"
          class="elevation-1 custom-table-style"
          :search="search"
          :items-per-page="itemsPerPage"
          :items-length="totalItems"
          disable-pagination
          :hide-default-footer="true"
          :fixed-header="true"
          :loading="loading"
        >
        <!-- FOR EXPANSION -->
        <template v-slot:expanded-row="{ columns, item }">
          <!-- <tr>
            <td :colspan="columns.length">               
              More info about {{ item.value.deviceId }}
            </td>
          </tr> -->
          <tr>
            <td :colspan="columns.length" style="max-width: 300px; word-wrap: break-word; padding: 10px;">
              {{ $t("license") }} : {{ item.raw.license }}
            </td>
          </tr>
          
          
        </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip :text="$t('Update')" location="top">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  small
                  class="mr-2"
                  color="green"
                  @click="compose_update(item.raw.id)"
                  v-if="
                    this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                    this.global_permissions.includes('ROLE_STAFF_USER')
                  "
                  >mdi-pencil-circle</v-icon
                >
              </template>
            </v-tooltip>
            <v-tooltip :text="$t('Delete')" location="top">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  small
                  class="mr-2"
                  color="red"
                  @click="compose_delete(item.raw.id)"
                  v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                  >mdi-delete-circle</v-icon
                >
              </template>
            </v-tooltip>
          </template>

          <template v-slot:bottom>
            <div class="text-center pt-2">
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="pageCount < 3 ? 3 : 7"
                @update:model-value="page"
              ></v-pagination>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <!-- ADD ORG DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_license") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="apps"
                      item-title="appName"
                      item-value="id"
                      :label="$t('select_app')"
                      required
                      v-model="license_data.f_appId"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="license_data.f_sn"
                      :items="serials"
                      item-title="id"
                      item-value="id"
                      :label="$t('search_sn')"
                      v-model:search="serialSearch"
                      :placeholder="$t('Start typing')"
                      hide-no-data
                      hide-selected
                      no-filter
                      required
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('license')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="license_data.f_license"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-select
                      :items="organizations"
                      item-title="orgName"
                      item-value="orgId"
                      :label="$t('Select Organization')"
                      required
                      v-model="license_data.f_orgId"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>* {{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addLicense"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE ACQUIRER DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_license") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="apps"
                      item-title="appName"
                      item-value="id"
                      :label="$t('select_app')"
                      required
                      v-model="license_data.f_appId"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="license_data.f_sn"
                      :items="serials"
                      item-title="id"
                      item-value="id"
                      :label="$t('search_sn')"
                      v-model:search="serialSearch"
                      :placeholder="$t('Start typing')"
                      hide-no-data
                      hide-selected
                      no-filter
                      required
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('license')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="license_data.f_license"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-select
                      :items="organizations"
                      item-title="orgName"
                      item-value="orgId"
                      :label="$t('Select Organization')"
                      required
                      v-model="license_data.f_orgId"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateLicense"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
            v-model="dialog_delete"
            persistent
            width="500"
          >              
            <v-card>
              <v-card-title>
                <span class="text-h5">do you want to delete?</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>                                           
                  </v-row>
                </v-container>                  
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                  
                <v-btn color="blue-darken-1" variant="text" @click="deleteLicense">Delete</v-btn>                 
              </v-card-actions>
            </v-card>
          </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black"> {{ $t("deleteText") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteLicense">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->

    <!-- UPLOAD  DIALOG -->
    <v-dialog v-model="dialog_excel" persistent width="500">
      <v-card class="pa-3">
        <div class="container">
          <span style="text-align: center">{{ $t("batch_upload") }}</span>
        </div>
        <span style="text-align: center">
          <!-- THIS ALLOWS ME TO DOWNLOAD .XLS FILE -->
          <!-- <download-excel
                        class="btn btn-default"
                        :data="template_merchants"
                        :fields="template_json_fields"
                        worksheet="Merchants"
                        name="Merchants.xls"
                      >
                        <v-btn density="compact" color="black">Download Merchant Template</v-btn>
                      </download-excel> -->
          <!-- THIS ALLOWS ME TO DOWNLOAD .XLXS FILE -->
          <vue-excel-xlsx
            class="btn btn-default"
            :data="data1"
            :columns="template_columns"
            :file-name="'Licenses'"
            :file-type="'xlsx'"
            :sheet-name="'Licenses'"
          >
            <!-- <v-btn density="compact" color="black">Download Template</v-btn> -->
            <v-btn height="52" min-width="164">{{
              $t("download_template")
            }}</v-btn>
            <!-- Download Template -->
          </vue-excel-xlsx>
        </span>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input> -->
                <v-file-input
                  show-size
                  clearable
                  label="File input"
                  @change="handleFileUpload($event)"
                ></v-file-input>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialog_excel = false">{{
              $t("Close")
            }}</v-btn>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="uploadLicenseFile"
              >{{ $t("Upload") }}</v-btn
            >
          </v-card-actions>
        </v-form>
        <div class="container">
          <small style="color: red"> *{{ $t("file_size") }}</small>
          <small style="color: red"> {{ $t("uplaod_text") }}</small>
        </div>
      </v-card>
    </v-dialog>
    <!-- END UPLOAD FILE DIALOG -->

    <!-- SELECT ORGANIZATION FOR EXPORT -->
    <v-dialog v-model="dialog_select_organization" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <v-select
                        :items="organizations"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                      
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_organization = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportLicenseData(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ORGANIZATION FOR EXPORT -->

  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "License",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      licenses: [],
      apps: [],
      serials: [],
      organizations: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,
      dialog_excel: false, //for upload
      dialog_select_organization: false,

      license_data: {
        f_appId: "",
        f_sn: "",
        f_license: "",
        f_expiry: "",
        f_orgId: "",
      },

      licenseId: "",
      headers: [
        {
          title: "SN",
          align: "start",
          sortable: false,
          key: "terminal.id",
        },
        { title: "", key: "data-table-expand" },
        { title: this.$t("app_id"), key: "app.id" },
        { title: this.$t("app_name"), key: "app.appName", width: "200px" },
        // { title: this.$t("license"), key: "license", width: "50px" },
        { title: this.$t("Organization"), key: "organization.orgName" },
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //THIS IS USED TO CREATE A TEMPLATE XLXS FILE FOR DOWNLOAD
      //THE FIELD HAS TO BE ACCORDING TO THE NAMING IN THE ENTITY CLASS
      //NB: THE USER HAS TO DOWNLOADED ET RE SAVE  THE .XLXS FILE BEFORE IT WILL WORK
      template_columns: [
        {
          label: "SN",
          field: "terminal.id",
        },
        {
          label: "APP ID",
          field: "app.id",
        },
        {
          label: "License",
          field: "license",
        },
        {
          label: "Expiry date",
          field: "expiryDate",
        },
        {
          label: "Organization ID",
          field: "organization.id",
        },
        {
          label: "Created By",
          field: "createdBy",
        },
      ],

      // data1   HERE IS ACCORDING THE MERCHANT ENTITY
      data1: [
        {
          terminal: {
            id: "",
          },
          app: {
            id: "",
          },
          license: "",
          expiryDate: "",

          organization: {
            id: "",
          },
          createdBy: "",
        },
      ],

      //form
      form: false,
      loading: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      // search: "",
      query: "", // Main search input
      serialSearch: "", // Dialog search input

      //select org for export
      select_acquirer: {
        f_acquirerId: "",        
      }, 
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    //auto-complete
    serialSearch(newSearch) {
      if (newSearch.length >= 2) {
        this.searchSn(newSearch); // Search for serial numbers
      } else {
        this.serials = [];
      }
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.license_data.f_appId = "";
      this.license_data.f_sn = "";
      this.license_data.f_license = "";
      this.license_data.f_expiry = "";
      this.license_data.f_orgId = "";
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.licenseId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.licenseId = id;
      this.dialog_delete = true;
    },

    compose_excel() {
      this.dialog_excel = true;
    },

    compose_select_organization() {
      this.dialog_select_organization = true;
      this.checkTokenExpiry();
      this.requests_handler4();
    },

    requests_handler4() {
      axios
        .all([
          axios.get(window.baseurl + "organizations", {            
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", acq_response.data);

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organizations = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organizations.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                  
                }
              }
            }
          })
        );
    }, //end of requests_handler4 method

    requests_handler() {
      axios
        .all([
          axios.get(window.baseurl + "appDetails", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "organizations", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((app_response, org_response) => {
            // console.log("data1", app_response.data);
            // console.log("data1", org_response.data);
            if (app_response.status == 200) {
              if (
                app_response.data.records != null &&
                app_response.data.records.length > 0
              ) {
                let i = 0;
                this.apps = [];
                for (i = 0; i < app_response.data.records.length; i++) {
                  this.apps.push({
                    id: app_response.data.records[i].id,
                    appName: app_response.data.records[i].appName,
                  });
                }
              }
            }

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organizations = [];
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organizations.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                }
              }
            }
          })
        );
    }, //end of requests_handler method

    async addLicense() {
      this.checkTokenExpiry();
      try {
        // console.log("form data", this.license_data);
        let result = await axios.post(
          window.baseurl + "licenses",
          {
            application_detail_id: this.license_data.f_appId,
            terminal_sn: this.license_data.f_sn,
            license: this.license_data.f_license,
            expiry: this.license_data.f_expiryDate,
            organization_id: this.license_data.f_orgId,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("license_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "" + "licenses/" + this.licenseId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "appDetails", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "organizations", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((license_response, app_response, org_response) => {
            // console.log("data1", license_response.data);

            if (license_response.status == 200) {
              this.license_data.f_appId = license_response.data.app.id;
              this.license_data.f_sn = license_response.data.terminal.id;
              this.license_data.f_license = license_response.data.license;
              this.license_data.f_expiry = license_response.data.expiryDate;
              this.license_data.f_orgId = license_response.data.organization.id;
            }

            if (app_response.status == 200) {
              if (
                app_response.data.records != null &&
                app_response.data.records.length > 0
              ) {
                let i = 0;
                this.apps = [];
                for (i = 0; i < app_response.data.records.length; i++) {
                  this.apps.push({
                    id: app_response.data.records[i].id,
                    appName: app_response.data.records[i].appName,
                  });
                }
              }
            }

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organizations = [];
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organizations.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateLicense() {
      //this.dialog_update = false
      this.checkTokenExpiry();
      try {
        // console.log("update form license id", this.licenseId);
        // console.log("update form curre..", this.license_data);
        let result = await axios.put(
          window.baseurl + "" + "licenses/" + this.licenseId,
          {
            application_detail_id: this.license_data.f_appId,
            terminal_sn: this.license_data.f_sn,
            license: this.license_data.f_license,
            expiry: this.license_data.f_expiryDate,
            organization_id: this.license_data.f_orgId,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form currency result", result);
        if (result.status == 200) {
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("license_updated") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteLicense() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "licenses/" + this.licenseId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("license_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    //UPLOAD FILE

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    async uploadLicenseFile() {
      // console.log("file" + this.file);
      this.checkTokenExpiry();
      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        try {
          let result = await axios.post(
            window.baseurl + "licenses/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer " + this.accessToken,
                "content-type": "multipart/form-data",
              },
            }
          );
          //console.warn("result", result);
          if (result.status == 201) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({message: result.data.message})
            this.$root.vtoast.show({
              message: this.$t("License Uploaded"),
            });
            window.setInterval(() => {
              this.dialog_excel = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
          this.loading = false;
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          // console.log("error", error);
          this.loading = false;
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      } else {
        // console.log("there are no files.");
        this.$root.vtoast.showError({ message: "There are no files" });
      }
    },

    async fetchData() {
      // console.log("in fecthData", this.page);
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "licenses", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("apps_object", result);
          this.licenses = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          //this.page = result.data.currentPage

          this.loading = false;
        }else if(this.global_permissions.includes("ROLE_USER_ADMIN") ||
        this.global_permissions.includes("ROLE_USER_ASSIST")){
          result = await axios.get( window.baseurl + "licenses/org/" + this.orgId, {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          console.log("apps_object", result);
          this.licenses = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          //this.page = result.data.currentPage

          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    //for search area databasee search
    async searchData() {
      // console.log("SearchData", "Working");
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "licenses/search", {
            params: { page: page2, pagesize: 100, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_licenses_object", result);
          this.licenses = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "licenses/org/search/" + this.orgId,
            {
              params: { page: page2, pagesize: 100, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_licenses_object", result);
          this.licenses = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
      }
    },

    //search sn
    async searchSn(search) {
      // console.log("in searchSn", search);
      let result;
      this.checkTokenExpiry();

      this.serials = [];
      //this.loading = true;
      let page2 = this.page - 1;
      if (search.length < 2) {
        this.items = [];
        return;
      }
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "terminals/search", {
            params: { page: page2, search: search },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("terminal_search_object", result);
          this.serials = result.data.records;
        }
      } catch (error) {
        this.show_toast(true, "warning", error.message);
      }
    },

    async downloadExcel2(orgId) {
      this.loading = true;
      try {
        
        const response = await fetch(window.baseurl + "licenses/export/org/" + orgId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {          
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "License";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          link.setAttribute('download', fileName);  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async exportLicenseData(id) {      
      //console.log("merchant_object44", id);      
      this.downloadExcel2(id);
      this.dialog_select_organization = false;     
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get data for table
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
